// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__MDU4f","savePackageButton":"ClientWallet_savePackageButton__FE80M"};